
import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/components/headers/form-header/form-header.vue';

import InputCCNumber from '@/components/inputs/text/cc_number.input.vue';
import InputCCType from '@/components/inputs/text/cc_type.input.vue';
import InputName from '@/components/inputs/text/name.input.vue';
import InputAge from '@/components/inputs/text/age.input.vue';
import InputEps from '@/components/inputs/text/eps.input.vue';
import InputEmail from '@/components/inputs/text/email.input.vue';
import InputPhone from '@/components/inputs/text/phone.input.vue';
import InputAddress from '@/components/inputs/text/address.input.vue';
import InputCity from '@/components/inputs/text/city.input.vue';

import InputBookingDate from '@/components/inputs/booking/booking-date.input.vue';
import InputBookingHour from '@/components/inputs/booking/booking-hour.input.vue';
import InputBookingSport from '@/components/inputs/booking/booking-sport.input.vue';

import InputPark from '@/components/inputs/options/park.input.vue';
import InputClientType from '@/components/inputs/options/client-type.input.vue';

import { IUser } from '@/models/IUser.model';
import { IPark } from '@/models/IPark.model';
import { BookingAPI } from '@/apis/bookings.api';

import moment from 'moment';
import { IBooking } from '@/models/IBooking.model';

@Component({
  components: {
    'form-header': FormHeader,
    'input-cc-number': InputCCNumber,
    'input-cc-type': InputCCType,
    'input-name': InputName,
    'input-age': InputAge,
    'input-eps': InputEps,
    'input-email': InputEmail,
    'input-phone': InputPhone,
    'input-address': InputAddress,
    'input-city': InputCity,
    'input-booking-date':InputBookingDate,
    'input-booking-hour':InputBookingHour,
    'input-booking-sport':InputBookingSport,
  },
})
export default class Home extends Vue {

  private cc_number = '';
  private parkId = '';
  private clientType = '';

  private cc_type: string = '';
  private name: string = '';
  private phone: string = '';
  private age: string = '';
  private eps: string = '';
  private email: string = '';
  private address: string = '';
  private city: string = '';
  private parent: any = {};

  private date = new Date(); 
  private hour = ''; 
  private bookings:IBooking[] = []; 

  private bookingSport = '';
  private bookingDate: Date = new Date();
  private bookingHour: string = '';

  private isUserLoaded = false;
  private isSeeMore = false;

  private mounted(){
    
    this.cc_number = this.$route.params.cc || this.user.cc_number;
    this.parkId = this.$route.params.parkId || this.park.name.replace(/[^A-Z0-9]+/ig, "_")
    this.clientType = this.$route.params.clientType || this.$store.state.clientType;
    const interval = setInterval(() => {
      this.cc_type = this.user.cc_type || (this.user as any).type;
      this.name = this.user.name;
      this.phone = this.user.phone;
      this.age = this.user.age;
      this.eps = this.user.eps;
      this.email = this.user.email;
      this.address = this.user.address;
      this.city = this.user.city;
      this.parent = {};
      this.isUserLoaded = true;
      clearInterval(interval);
    }, 500)
    
    this.$store.dispatch('setParkById', this.parkId);
    this.$store.dispatch('fetchBookingByParkName', this.park.name);

  }

  setToogleSeeMore(){
    this.isSeeMore = !this.isSeeMore;
  }
  
  setCity($text) {
    this.city = $text;
  }
  setAddress($text) {
    this.address = $text;
  }
  setEmail($text) {
    this.email = $text;
  }
  setPhone($text) {
    this.phone = $text;
  }
  setEps($text) {
    this.eps = $text;
  }
  setAge($text) {
    this.age = $text;
  }
  setName($text) {
    this.name = $text;
  }
  setCCNumber($text) {
    this.cc_number = $text;
  }
  setCCType($text) {
    this.cc_type = $text
  }
  onBookingSportChange($text){
    this.bookingSport = $text
  }
  onBookingDateChange($text){
    this.bookingDate = $text
    this.date = $text;
  }
  onBookingHourChange($text){
    this.bookingHour = $text;
  }

  public get user(): IUser {
    return this.$store.state.user;
  }

  public get park(): IPark {
    return this.$store.state.park;
  }

  async doBookUp(){

    if(this.bookingDate && this.bookingHour && this.bookingSport){
      const bookApi = new BookingAPI();

      const bookDDMMYYYY = moment(this.date).format('DDMMYYYY');
      const bookID = 
        bookDDMMYYYY + '_' + 
        this.bookingHour + '_' +
        (this.user.cc_type || (this.user as any).type) + '_' +
        (this.user.cc_number || (this.user as any).cc);
        
      const bookPayload = {
        id: bookID,
        date: this.date,
        hour: this.bookingHour,
        ddmmyyyy: bookDDMMYYYY,
        parkName: this.park.name,
        cc_number: this.user.cc_number || (this.user as any).cc,
        cc_type: this.user.cc_type || (this.user as any).type, 
        name: this.user.name,
        email: this.user.email,
        city: this.user.city,
        phone: this.user.phone,
        address: this.user.address,
        age: this.user.age,
        eps: this.user.eps,
        sport: this.bookingSport
      };     
    
      try{
        await bookApi.post(bookPayload)
      } catch(err){
        console.error('await bookApi.post(bookPayload)')
        console.error({bookPayload})
        console.error({err})
      }
      
      this.$swal('Reservado Exitosamente', `
      <p class="form-p" style="text-align: left;width: 100%;margin: 0px auto;padding: 0px 0px; padding-top:46px; padding-bottom:46px; ">
        CC : ${this.user.cc_number} <br>
        Fecha Reserva : ${moment(bookDDMMYYYY,'DDMMYYYY').format('DD/MM/YYYY')} <br>
        Hora Reserva : ${Vue.filter('formatHourName')(this.bookingHour)} <br>
        Parque : ${this.park.name} <br>
      </p>
      <br>
      <p class="form-p" style="text-align: left;width: 100%;margin: 0px auto;padding: 0px 0px; ">
      RECOMENDACIONES PARA USO DEL PARQUE: 
      <br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg"> No está permitido el ingreso de bicicleta a los escenarios deportivos. <br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg"> Mantener puesto el tapabocas todo el tiempo.  <br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg"> Debe portar sus elementos de bioseguridad como gel antibacterial o alcohol al 70%.  <br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg"> Portar una tolla de uso personal. <br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg">Recuerde que el aforo máximo para los parques es de 60 personas. 
<br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg">Para los escenarios Skate Park y Parque de los Niños el aforo será máximo de 30 personas (entre niños y adultos).  <br>
      <img style="padding: 1em 0em;top: -1px; width: 14px;display: inline;" 
      src="https://www.flaticon.com/svg/static/icons/svg/907/907830.svg">Recuerde que sus datos personales están protegidos por el habeas data de Cundeportes Funza.  <br>
   </p>
      `,'success');
      setTimeout(() => {
        this.$router.push({ name: 'IndexView'});
      }, 5000)

    } else {
      //this.$router.push({ name: 'SignUpView', params: { cc: cc, park: parkId , clientType: clientType } });
    }

  }


  hourStringToNumber = {
    'hour600am_730am': "06:00:00 AM",
    'hour800am_930am': "08:00:00 AM",
    'hour1000am_1130am': "10:00:00 AM",
    'hour1200am_0130pm': "12:'00:00 AM",
    'hour200pm_330pm': "02:00:00 PM",
    'hour400pm_530pm': "04:00:00 PM",
    'hour600am_700am': "06:00:00 PM",
    'hour800am_900am': "08:00:00 AM",
    'hour1000am_1100am': "10:00:00 AM",
    'hour1200am_0100pm': "12:00:00 AM",
    'hour0300pm_0400pm': "03:00:00 PM",
    'hour0500pm_0600pm': "05:00:00 PM",
  }
  

}